import React from 'react';
import { func } from 'prop-types';
import {
  Button,
  ButtonGroup,
  DrawerBody,
  DrawerFooter,
  Typography,
  Alert
} from '@one-thd/sui-atomic-components';

export const SignInDrawer = ({ onClose }) => {
  const thisUrl = window.location.href;
  return (
    <>
      <DrawerBody>
        <Alert status="info">
          Please Sign In to Add to Quote
        </Alert>
      </DrawerBody>
      <DrawerFooter>
        <ButtonGroup orientation="vertical">
          <Button
            fullWidth
            variant="primary"
            href={`/auth/view/signin?redirect=/&ref=${thisUrl}`}
          >
            Sign In
          </Button>
          <Button
            fullWidth
            variant="secondary"
            onClick={onClose}
          >
            Cancel
          </Button>
        </ButtonGroup>
      </DrawerFooter>
    </>
  );
};

SignInDrawer.propTypes = {
  onClose: func.isRequired
};

SignInDrawer.displayName = 'AddToQuoteSignInDrawer';